defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/ActivityFeed/GameCard',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/TimeUtils/Scripts/TimeUtils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCountdown',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard'
  ],
  function (m, TimeUtils, Utils, PlayCountdown, PostCard) {
    const numbergamesIconsPath = '/Components/DanskeSpil/Domain/NumberGamePackage/Graphics/SpriteSheets/PackageCommonIcons.svg#';
    const gameNamesMap = {
      LottoSaturday: 'lotto',
      VikingLotto: 'vikinglotto',
      EuroJackpot: 'eurojackpot'
    };
    const gameLogoNames = {
      eurojackpot: 'icon-eurojackpot_logo_bg_yellow',
      lotto: 'icon-lotto_logo_white',
      vikinglotto: 'icon-vikinglotto_logo_white'
    };

    // View:
    var GameCard = {
      controller: function ({ controller, feedPost }) {
        Object.assign(this, controller);

        this.gameName = gameNamesMap[feedPost.gameType];

        let gameLogoHref = `${numbergamesIconsPath}${gameLogoNames[this.gameName]}`;
        if (feedPost.type === 'GameFundedSubscription') {
          gameLogoHref = '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#spilSammen-plus_logo';
          this.gameName = 'play-together-subscription';
        }
        this.$header = [
          ['SubscriptionCreated', 'SubscriptionJoined'].includes(feedPost.type) ?
            m('svg.play-together-club-activity-feed__game-icon', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#spilSammen-plus_logo'
            })) : null,
          m('svg.play-together-club-activity-feed__game-icon', m('use', {
            href: gameLogoHref
          }))
        ];
        this.$footer = null;

        if (feedPost.subType === 'NoPrize') {
          this.$header.push(
            m('img.play-together-club-activity-feed__no-winnings-image', {
              src: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/palm_tree.svg'
            })
          );
        }
      },
      view: function (controller, { feedPost, index }) {
        const message = feedPost.message;

        if (feedPost.subType === 'Countdown') {
          const countdownTarget = Utils.parseISO8601(feedPost.timeStamp).dateObject;

          if (Utils.isSameDay(TimeUtils.getCurrentDateTime(), countdownTarget)) {
            message.message = null;
            controller.$footer = PlayCountdown({
              timestamp: countdownTarget
            });
          }
        }

        const postCardOptions = {
          className: `play-together-club-activity-feed__game--${controller.gameName}`,
          title: message?.header,
          description: message?.message,
          $header: controller.$header,
          $footer: controller.$footer,
          keyIndex: index
        };

        // View:
        return PostCard(postCardOptions);
      }
    };

    // Public functions:
    return GameCard;

  });
